module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    attrs: {
      "icon": _vm.icon,
      "type": _vm.type,
      "loading": _vm.loading,
      "title": (_vm.title ? _vm.title : _vm.value),
      "size": _vm.size,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('span', {
    staticClass: "d-none d-sm-inline d-xl-inline"
  }, [_vm._v("\n    " + _vm._s(_vm.value) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66eca2d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/common/button.vue
// module id = 1529
// module chunks = 45